import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import HeroSection from './components/HeroSection';
import HotComments from './components/HotComments';
import TopicCollections from './components/TopicCollections';
import GossipFeed from './components/GossipFeed';
import CommentBoard from './components/CommentBoard';
import SubscribeBar from './components/SubscribeBar';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <HotComments />
        <TopicCollections />
        <GossipFeed />
        <CommentBoard />
        <SubscribeBar />
      </main>
      <SiteFooter />
    </div>
  );
}